import {ChatManager} from './ChatManager';

export default ChatManager;